import React, { useEffect, useState } from "react";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Hero from "./components/sections/Hero";
import ClubInfo from "./components/sections/ClubInfo";
import Membership from "./components/sections/Membership";
import Sessions from "./components/sections/Sessions";
import About from "./components/sections/About";
import Committee from "./components/sections/Committee";
import Gallery from "./components/sections/Gallery";
import Contact from "./components/sections/Contact";



function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
  }, [darkMode]);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <Header
        darkMode={darkMode}
        onToggleDark={() => setDarkMode((d) => !d)}
        onNavClick={scrollToSection}
      />
      <main>
        <section id="home">
    
            <Hero onJoinClick={() => scrollToSection("membership")} />
         
        </section>

        <section id="club-info" className="section">
          <ClubInfo />
        </section>

        <section className="section section-alt">
          <About type="why" />
        </section>

        <section id="membership" className="section">
          <Membership />
        </section>

        <section className="section section-alt">
          <About type="priority" />
        </section>

        <section id="sessions" className="section">
          <Sessions />
        </section>

        <section id="about" className="section section-alt">
          <About type="about" />
        </section>

        <section className="section">
          <Committee />
        </section>

        <section id="gallery" className="section section-alt">
          <Gallery />
        </section>

        <section id="contact" className="section">
          <Contact />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default App;
